import { ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "../../context";

interface Props {
  ability: string;
  fallback?: string;
  children: ReactElement;
}

const RequireAbility = ({ ability, fallback = "/", children }: Props) => {
  const { can } = useUser();
  return can(ability) ? children : <Navigate to={fallback} replace />;
};

export default RequireAbility;
